
// SERVICES
export const GET_SERVICES = "/services";
export const ADD_NEW_SERVICE = "/services";
export const UPDATE_SERVICE = "/services";
export const DELETE_SERVICE = "/services";


